import React from "react";
import Home from "pages/Home";
import { Footer } from "layouts";

function App() {
  return (
    <div className="App">
      <Home />
			<Footer />
    </div>
  );
}

export default App;
